import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";

const GatsbyImageWithSVGSupport = ({
    image: { gatsbyImageData, file, title, description },
    alt,
    className,
    loading = "lazy",
    fetchPriority,
}) => {
    const altText = alt || description || title || file?.url || "";

    if (gatsbyImageData?.images && file?.contentType !== "image/gif") {
        return (
            <GatsbyImage
                key={gatsbyImageData.images[0]?.src || altText}
                image={gatsbyImageData}
                alt={altText}
                className={className}
                loading={loading}
                fetchPriority={fetchPriority}
            />
        );
    } else if (file?.url) {
        // This branch is needed for supporting SVG images coming from Contentful
        return (
            <img
                key={file.url}
                src={file.url}
                alt={altText}
                className={className}
                loading={loading}
            />
        );
    }
};

GatsbyImageWithSVGSupport.propTypes = {
    image: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        gatsbyImageData: PropTypes.object,
        file: PropTypes.shape({
            contentType: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    }).isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
    loading: PropTypes.string,
    fetchPriority: PropTypes.string,
};

export default GatsbyImageWithSVGSupport;
